import { Checkbox, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';
import { IStyledCheckboxProps } from './types';

export const StyledCheckbox = styled(Checkbox)((props: IStyledCheckboxProps) => ({
  svg: {
    color: theme.palette.orange.light,
  },
}));
